export function getCustomerCareUrl(language?: string | null): string {
  const lang = (
    language ??
    (typeof localStorage !== 'undefined'
      ? localStorage.getItem('i18nextLng')
      : null) ??
    ''
  ).toLowerCase();
  return lang.startsWith('it')
    ? 'https://www.archivagroup.com/it/us/support/customer-care'
    : 'https://www.archivagroup.com/en/us/support/customer-care';
}
